import React from 'react'

/** Figma Ellipse 8 (1) — mobile glow (tüm container) */
const MobileGlowBg: React.FC = () => (
  <svg
    width="88"
    height="195"
    viewBox="0 0 88 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    preserveAspectRatio="xMaxYMid slice"
  >
    <g filter="url(#pf_mobile_glow_filter0)">
      <ellipse
        cx="162.281"
        cy="106.227"
        rx="82.9223"
        ry="24.3787"
        transform="rotate(-7.11344 162.281 106.227)"
        fill="#7340E6"
      />
    </g>
    <defs>
      <filter
        id="pf_mobile_glow_filter0"
        x="0"
        y="0"
        width="324.562"
        height="212.455"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="39.9702" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
)

export default MobileGlowBg
